import { render, staticRenderFns } from "./EditarProducto.vue?vue&type=template&id=1270bd2f"
import script from "./EditarProducto.vue?vue&type=script&lang=js"
export * from "./EditarProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports